import { PocketPickGame } from '@/screens/pocketPick/PocketPickGame'

export default function () {
  return <PocketPickGame />
}
